// `extension-alert-candidate-pagination.tpl.html` — Prev / n / m / Next under the list.
//
// ⚠️ `ng-disabled` ON AN `<a>` DOES NOTHING, and that is what is being ported. AngularJS's
// `ngDisabled` sets the `disabled` PROPERTY, which anchors do not have — so upstream's first
// and last pages still have clickable Prev and Next links, and `movePage` is what keeps the
// page in range. Rendering a genuinely disabled control here would look more correct and would
// diverge: the link is styled as active in every reference capture, including the first page.
//
// So the attribute is reproduced (it renders as `disabled="disabled"` on the element, which is
// what the stylesheet may key off) and the CLAMP is done in the handler, as upstream does.
import type { ReactElement } from 'react'

export interface CandidatePaginationProps {
  currentPage: number
  lastPage: number
  onMove?: (delta: number) => void
}

export function CandidatePagination({ currentPage, lastPage, onMove }: CandidatePaginationProps): ReactElement {
  const move = (delta: number): void => {
    const next = currentPage + delta
    // `movePage` refuses to leave the range rather than the link refusing to be clicked.
    if (next < 1 || next > lastPage) return
    onMove?.(delta)
  }

  return (
    <div className="ext-alerts-pagination">
      <span className="prev-page">
        <a
          href=""
          aria-disabled={currentPage === 1}
          onClick={(event) => {
            event.preventDefault()
            move(-1)
          }}
        >
          <i className="fas fa-chevron-left" /> Prev
        </a>
      </span>
      <span className="curr-page">
        {currentPage} / {lastPage}
      </span>
      <span className="next-page">
        <a
          href=""
          aria-disabled={currentPage === lastPage}
          onClick={(event) => {
            event.preventDefault()
            move(1)
          }}
        >
          Next <i className="fas fa-chevron-right" />
        </a>
      </span>
    </div>
  )
}
